import { create } from 'zustand'
import { Variant } from '../model/product.model'

type State = {
  selectedVariant: Variant | null
  setVariant: (variant: Variant | null) => void
}

export const useSelectedVariant = create<State>(set => ({
  selectedVariant: null,
  setVariant: variant => set({ selectedVariant: variant }),
}))
